import { RouteDtoModelType } from '../models';

export type RouteProps = {
  ids: string[];
  uuids: string[];
  isBeingModified: boolean;
  isDispatched: boolean;
  isLocked: boolean;
  isLoading?: boolean;
  isReversing?: boolean;
  disabled?: boolean;
  noOrders: boolean;
  isDeleting?: boolean;
  finished?: boolean;
  isStarted?: boolean;
};

type RoutesPropsWithoutUuidsOrIds = Omit<RouteProps, 'uuids' | 'ids'>;

const getProps = (cur: RouteDtoModelType) => ({
  isBeingModified: cur.isBeingModified,
  isDispatched: cur.isDispatched,
  isLocked: cur.isLocked,
  isReversing: cur.isReversing,
  isDeleting: cur.isDeleting,
  isStarted: cur.isStarted,
  finished: cur.finished,
});

const getRoutesProps = (routes: RouteDtoModelType[]) => routes.reduce((acc: RouteProps, cur: RouteDtoModelType) => {
  const currentRouteProps = getProps(cur);

  const noRouteHasOrders = routes.every(r => r.totalOrdersCount === 0);

  Object.entries(currentRouteProps).forEach(([key, value]) => {
    if (!acc[key as keyof RoutesPropsWithoutUuidsOrIds] && value) {
      acc[key as keyof RoutesPropsWithoutUuidsOrIds] = true;
    }
  });

  if (cur.id) {
    acc.ids.push(cur.id);
  }

  if (cur.uuid) {
    acc.uuids.push(cur.uuid);
  }

  if (noRouteHasOrders) {
    acc.noOrders = true;
  }

  if (cur.isDeleting) {
    acc.isDeleting = true;
  }

  return acc;
}, {
  ids: [],
  uuids: [],
  isBeingModified: false,
  isDispatched: false,
  isLocked: false,
  isReversing: false,
  noOrders: false,
  isDeleting: false,
  finished: false,
  isStarted: false,
});

export default getRoutesProps;
